import { render, staticRenderFns } from "./Flavor.Form.vue?vue&type=template&id=02ae0edf&scoped=true"
import script from "./Flavor.Form.vue?vue&type=script&lang=js"
export * from "./Flavor.Form.vue?vue&type=script&lang=js"
import style0 from "./Flavor.Form.vue?vue&type=style&index=0&id=02ae0edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae0edf",
  null
  
)

export default component.exports